module.exports = {
	Home: '/',
	Terms: '/terms',
	Privacy: '/privacy',
	Confirm: '/confirm',
	Share: '/share'
}
